import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import Panel from 'components/Helpers/Panel';
import Link from 'components/Link';

import s from './WhatYouGet.css';
// import iphone8 from './iphone8.png';
import macbook from './macbookpro15.png';
import { StarStruck } from '../../../Emoji';

// const ActionText = () => (
//   <div>
//     <p className="lead text-danger">
//       Безлімітний термін просування оголошення в пакеті <br />{' '}
//       <b style={{ 'text-decoration': 'underline' }}>Все включено PRO</b>
//     </p>
//     {/* <p className="lead text-danger"> */}
//     {/*  50% знижки на всі послуги, акція дійсна до 10.04 */}
//     {/* </p> */}
//   </div>
// );

const WhatYouGet = () => (
  <div className={s.root}>
    <Panel>
      <Row>
        <Col xs="12" md="6">
          <img src={macbook} className={s.mockup} alt="ios view" />
        </Col>
        <Col xs="12" md="6">
          <p className={`h3 ${s.heading}`}>
            <FormattedMessage
              id="sell_auto.features.heading"
              defaultMessage="Ви отримаєте"
              description=""
            />
          </p>
          <ul className={s.features}>
            <li>
              <FormattedMessage
                id="sell_auto.features.1"
                defaultMessage="Будь-яку кількість оголошень БЕЗКОШТОВНО"
                description=""
              />
              *
            </li>
            <li>
              <FormattedMessage
                id="sell_auto.features.2.1"
                defaultMessage="Ваше оголошення з'явиться у"
                description=""
              />{' '}
              <Link to="/cars">
                <FormattedMessage
                  id="sell_auto.features.2.2"
                  defaultMessage="пошуку"
                  description=""
                />
              </Link>{' '}
              <FormattedMessage
                id="sell_auto.features.2.3"
                defaultMessage="МИТТЄВО"
                description=""
              />
            </li>
            <li>
              <FormattedMessage
                id="sell_auto.features.3"
                defaultMessage="Можливість вибрати модифікацію авто та не вказувати технічні характеристики, вони будуть додані АВТОМАТИЧНО"
                description=""
              />
            </li>
            <li>
              <FormattedMessage
                id="sell_auto.features.4"
                defaultMessage="Розміщення оголошення з яскравими фото Вашої марки та моделі"
                description=""
              />
            </li>
            <li>
              <FormattedMessage
                id="sell_auto.features.5"
                defaultMessage="Можливість редагувати Ваше оголошення БЕЗ ОБМЕЖЕНЬ"
                description=""
              />
            </li>
            <li>
              <FormattedMessage
                id="sell_auto.features.6"
                defaultMessage="Онлайн підтримку та персонального менеджера, що допоможуть вирішити будь-яку проблему"
                description=""
              />
            </li>
          </ul>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          {/* <ActionText /> */}
          <p>
            <FormattedMessage
              id="sell_auto.action.alert"
              defaultMessage="Не гайте часу - продайте швидко з"
              description=""
            />{' '}
            <strong>Автопрод</strong> <StarStruck />!
          </p>
          <a href="#add_form" className="btn btn-success btn-lg">
            <FormattedMessage
              id="sell_auto.action.button"
              defaultMessage="Розмістити оголошення"
              description=""
            />
          </a>
        </Col>
      </Row>
    </Panel>
    <p className="small text-muted text-center m-2">
      *{' '}
      <FormattedMessage
        id="sell_auto.notice.free_publish"
        defaultMessage="безкоштовне розміщення на 2 тижні"
        description=""
      />
      .
    </p>
  </div>
);

export default withStyles(s)(WhatYouGet);
